import React, { useEffect, useState } from "react";
import { useBuilding } from "../../context/BuildingContext";
import { reportsApi, unitsApi } from "../../services/api";
import GenericReportViewer from "./GenericReportViewer";

interface Props {
  period: string;
}

const UnitStatementReport: React.FC<Props> = ({ period }) => {
  const { currentBuilding } = useBuilding();
  const [units, setUnits] = useState<any[]>([]);
  const [unitId, setUnitId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [report, setReport] = useState<any>(null);

  useEffect(() => {
    if (!currentBuilding?.id) return;
    let cancelled = false;
    unitsApi
      .getAll(currentBuilding.id)
      .then((items: any[]) => {
        if (cancelled) return;
        setUnits(items || []);
        if (items?.length && !unitId) setUnitId(items[0].id);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [currentBuilding?.id]);

  useEffect(() => {
    if (!currentBuilding?.id || !unitId) return;
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await reportsApi.getUnitStatement(currentBuilding.id, {
          unitId,
          period,
        });
        if (!cancelled) setReport(data);
      } catch (e) {
        console.error(e);
        if (!cancelled) setError("Failed to load unit statement.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [currentBuilding?.id, unitId, period]);

  return (
    <div>
      <div className="bg-white shadow rounded-lg p-4 mb-4">
        <label className="block text-xs uppercase text-gray-500 mb-1">
          Unit
        </label>
        <select
          value={unitId}
          onChange={(e) => setUnitId(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2 w-full"
        >
          {units.map((u) => (
            <option key={u.id} value={u.id}>
              {u.unitNumber || u.name || u.id}
            </option>
          ))}
        </select>
      </div>
      <GenericReportViewer
        title="Unit / Leaseholder Statement"
        loading={loading}
        error={error}
        report={report}
      />
    </div>
  );
};

export default UnitStatementReport;
